import { Type } from 'class-transformer';

export default class FinancialInformationModel {
  nomeDataSource!: string;

  cnpjCpf!: string;

  codCliente!: string;

  titulo!: string;

  banco!: number;

  nomePortador!: string;

  @Type(() => Date)
  dataEmissao!: Date;

  @Type(() => Date)
  dataVencimento!: Date;

  @Type(() => Date)
  dataVencimentoOriginal?: Date;

  @Type(() => Date)
  dataBaixa?: Date;

  valorLiquido!: number;

  situacao!: string;

  nomeTipoCobranca?: string;

  qtdeDiasAtraso!: number;

  nomeCliente?: string;

  pedido?: string;

  posicao?: string;

  cnpjTitulo?: string;

  saldoDuplicata!: number;

  notaFiscal?: string;
}
